module.exports = __webpack_public_path__ + "img/niews-1.85754c1a.jpg";